export enum ZaznamSekcieTypEnum {
  JudikatSk= 'JUDIKAT_SK',
  JudikatEu= 'JUDIKAT_EU',
  RozhodnutieSkSudu= 'ROZHODNUTIE_SK_SUDU',
  RozhodnutieEuSudu= 'ROZHODNUTIE_EU_SUDU',
  PravoEu= 'PRAVO_EU',
  Eurovoc= 'EUROVOC'
}

export const typSekcieNazov = (typSekcie: ZaznamSekcieTypEnum): string => {
  switch (typSekcie) {
    case ZaznamSekcieTypEnum.JudikatSk: return 'Judikát SK';
    case ZaznamSekcieTypEnum.JudikatEu: return 'Judikát EÚ';
    case ZaznamSekcieTypEnum.RozhodnutieSkSudu: return 'Rozhodnutie súdu SK';
    case ZaznamSekcieTypEnum.RozhodnutieEuSudu: return 'Rozhodnutie súdu EÚ';
    case ZaznamSekcieTypEnum.PravoEu: return 'Právo EÚ';
    case ZaznamSekcieTypEnum.Eurovoc: return 'EuroVoc';
    default: return '';
  }
};
